module.exports = __webpack_public_path__ + "static/media/anchor.94fd5557.svg";